import React from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import { useSelector } from 'react-redux';
import { selectRenewalTotal } from '../duck/selectors';
import { State } from 'model/State';
import { StyledValueWrapper, StyledWrapper } from './PaymentMethodsTable';
import { FormattedMessage } from 'react-intl';
import { messages } from '../messages';
import config from 'appconfig';

export const PaymentMethodRow = ({
  isChecked,
  product,
  name,
  sen,
  renewsOn,
  currentPaymentMethod,
  setAccountsSelected,
}) => {
  const estimatedPrice = useSelector((state) => selectRenewalTotal(state as State, sen));

  const onChange = () => {
    setAccountsSelected((prevState) => {
      if (!isChecked) {
        return [...prevState, sen];
      }
      return prevState.filter((item) => item !== sen);
    });
  };

  return (
    <>
      <StyledWrapper data-cy={`payment-method-row-${sen}`}>
        <StyledValueWrapper width="5%">
          <Checkbox data-cy={`row-checkbox-${sen}`} isChecked={isChecked} onChange={onChange} />
        </StyledValueWrapper>
        <StyledValueWrapper width="15%">
          <p>{product}</p>
        </StyledValueWrapper>
        <StyledValueWrapper width="15%">
          <p>{name}</p>
        </StyledValueWrapper>
        <StyledValueWrapper width="15%">
          <p>{`SEN-${sen}`}</p>
        </StyledValueWrapper>
        <StyledValueWrapper width="14%">
          <p>{renewsOn}</p>
        </StyledValueWrapper>
        <StyledValueWrapper width="16%">
          {estimatedPrice ? (
            <p>{estimatedPrice}</p>
          ) : (
            <FormattedMessage
              {...messages.unableToCalculateRenewal}
              values={{
                contactUs: (
                  <a href={config.companyContact}>
                    <FormattedMessage {...messages.paymentContactUs} />
                  </a>
                ),
              }}
            />
          )}
        </StyledValueWrapper>
        <StyledValueWrapper width="20%">
          <p>{currentPaymentMethod}</p>
        </StyledValueWrapper>
      </StyledWrapper>
    </>
  );
};
